import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [uatConfig, setUatConfig] = useState(undefined); // undefined = loading, null is no longer used

  useEffect(() => {
    // Check UAT mode config (public endpoint — no auth required)
    axios.get(`${API}/auth/uat-config`)
      .then(res => setUatConfig(res.data))
      .catch(() => setUatConfig({ error: true })); // Never silently fall back to STANDARD

    // Check existing session
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(res => setUser(res.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    if (data.requires_2fa) {
      return data; // { requires_2fa: true, challenge_id }
    }
    setUser(data);
    return data;
  };

  const verify2FA = async (challenge_id, code) => {
    const { data } = await axios.post(`${API}/auth/verify-2fa`, { challenge_id, code }, { withCredentials: true });
    setUser(data);
    return data;
  };

  /** UAT role-picker: one-click login as a seeded persona by role_code.
   *  SEC-ADMIN-01: pass step_up_token for privileged roles after PIN verification. */
  const uatRoleLogin = async (role_code, step_up_token) => {
    const payload = { role_code };
    if (step_up_token) payload.step_up_token = step_up_token;
    const { data } = await axios.post(
      `${API}/auth/uat-role-login`,
      payload,
      { withCredentials: true }
    );
    setUser(data);
    return data;
  };

  const logout = async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, verify2FA, uatRoleLogin, logout, uatConfig }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
